(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3478],{

/***/ 73478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SliderView": function() { return /* binding */ SliderView; },
  "default": function() { return /* binding */ SliderView_SliderView; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/components/index.js + 114 modules
var components = __webpack_require__(47696);
// EXTERNAL MODULE: ./src/shared/components/Tabs/Tabs.Provider.js
var Tabs_Provider = __webpack_require__(11742);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./src/shared/components/Tabs/Tabs.hooks.js
var Tabs_hooks = __webpack_require__(60419);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 14 modules
var swiper_react = __webpack_require__(88494);
// EXTERNAL MODULE: ./src/components/widgets/content/Content006/Item/index.js + 1 modules
var Item = __webpack_require__(44233);
// EXTERNAL MODULE: ./src/components/widgets/content/Content006/SliderItem/SliderItem.module.scss
var SliderItem_module = __webpack_require__(48028);
var SliderItem_module_default = /*#__PURE__*/__webpack_require__.n(SliderItem_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content006/SliderItem/SliderItem.jsx









var SliderItem = function(param) {
    var items = param.items, prevRef = param.prevRef, nextRef = param.nextRef, pagination = param.pagination, paginationWrapper = param.paginationWrapper;
    var ref = (0,Tabs_hooks/* useTabsState */.n)(), activeTab = ref.activeTab, isDefaultTab = ref.isDefaultTab, tabsEnabled = ref.tabsEnabled;
    var filterItems = (0,react.useMemo)(function() {
        if (isDefaultTab || !tabsEnabled) {
            return items;
        }
        return items.filter(function(param) {
            var tag = param.tag;
            return tag.toLowerCase() === activeTab.toLowerCase();
        });
    }, [
        isDefaultTab,
        tabsEnabled,
        items,
        activeTab
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (SliderItem_module_default()).slider,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SwiperLayout */.OJ, {
            paginationWrapper: paginationWrapper,
            slidesPerView: 3,
            prevRef: prevRef,
            nextRef: nextRef,
            children: filterItems.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    className: (SliderItem_module_default()).wrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* Item */.c, (0,_object_spread/* default */.Z)({
                        className: classnames_default()((SliderItem_module_default()).item, (SliderItem_module_default()).slide)
                    }, item))
                }, item.id);
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content006/SliderItem/index.js


// EXTERNAL MODULE: ./src/components/widgets/content/Content006/SliderView/SliderView.module.scss
var SliderView_module = __webpack_require__(50176);
var SliderView_module_default = /*#__PURE__*/__webpack_require__.n(SliderView_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content006/SliderView/SliderView.jsx







var SliderView = function(param) {
    var items = param.items, title = param.title, description = param.description, extractedTabs = param.extractedTabs, tabsEnabled = param.tabsEnabled;
    var prevRef = react.useRef(null);
    var nextRef = react.useRef(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Container */.W2, {
                className: (SliderView_module_default()).header,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (SliderView_module_default()).top,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (SliderView_module_default())["top-content"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: (SliderView_module_default()).title,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                color: "grey",
                                className: (SliderView_module_default()).description,
                                children: description
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs_Provider/* TabsProvider */.X, {
                items: extractedTabs,
                defaultTab: true,
                tabsEnabled: tabsEnabled,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Container */.W2, {
                        className: (SliderView_module_default()).header,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (SliderView_module_default())["top-navigation"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Tabs */.mQ, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (SliderView_module_default())["navigation-wrapper"],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (SliderView_module_default()).pagination
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (SliderView_module_default())["slider-navigation"],
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    ref: prevRef,
                                                    className: classnames_default()((SliderView_module_default()).navigation, (SliderView_module_default())["navigation-prev"]),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                        className: (SliderView_module_default()).icon,
                                                        name: "arrow_slider_prev"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    ref: nextRef,
                                                    className: classnames_default()((SliderView_module_default()).navigation, (SliderView_module_default())["navigation-next"]),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                        className: (SliderView_module_default()).icon,
                                                        name: "arrow_slider_next"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderItem, {
                        items: items,
                        nextRef: nextRef,
                        prevRef: prevRef,
                        paginationWrapper: (SliderView_module_default()).pagination
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SliderView_SliderView = (SliderView);


/***/ }),

/***/ 48028:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"SliderItem_item__GT6CV","slide":"SliderItem_slide__LcZN2","slider":"SliderItem_slider__WV0le"};

/***/ }),

/***/ 50176:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SliderView_wrapper__JyMwr","title":"SliderView_title__NkStI","description":"SliderView_description__QZZnM","top-content":"SliderView_top-content__IGmG3","top-navigation":"SliderView_top-navigation__U53GM","navigation-wrapper":"SliderView_navigation-wrapper__WkUzr","pagination":"SliderView_pagination__8iZel","slider-navigation":"SliderView_slider-navigation__jPwUh","navigation":"SliderView_navigation__XHA9y","navigation-prev":"SliderView_navigation-prev__6fnRB","navigation-next":"SliderView_navigation-next__IdIrL"};

/***/ })

}]);